import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { removeUser } from '../../store/actions/auth/auth.action';
import { getCategories } from '../../store/actions/admins/admins.action';
import { setCategories } from '../../store/actions/auth/auth.action';
import _ from 'lodash';

import '../../utils/tree.util.js';
import '../../utils/pushmenu.util.js';

import userPlaceholder from '../../assets/images/user-placeholder.png';
import '../../styles/sidebar.css';

import logo from '../../assets/images/logo.png';
import logoNoText from '../../assets/images/logoNoText.png';

const Sidebar = ({ sidebarOpen }) => {
    // Redux hooks
    const dispatch = useDispatch();

    // Redux state
    const user = useSelector((state) => state.auth.user);
    const allCategories = useSelector((state) => state.admin.categories);
    const categories = useSelector((state) => state.auth.categories);

    // Initialize categories on mount
    useEffect(() => {
        if (user) {
            dispatch(getCategories()).then(() => {
                // This will be handled after categories are fetched
            });
        }
    }, [dispatch, user]);

    // Process categories when allCategories or user changes
    useEffect(() => {
        if (user && allCategories && allCategories.length > 0) {
            let processedCategories = allCategories;

            if (user.role === 'subadmin') {
                let { assigned_categories } = user;
                assigned_categories = assigned_categories.split(',');
                processedCategories = _.filter(allCategories, ({ id }) => {
                    return assigned_categories.includes(id + '|edit') || assigned_categories.includes(id + '|view');
                });

                processedCategories = processedCategories.map((category) => {
                    let cat = _.filter(
                        assigned_categories,
                        (cat) => cat === category.id + '|view' || cat === category.id + '|edit'
                    )[0];
                    return {
                        ...category,
                        mode: cat.split('|')[1],
                    };
                });
            } else if (user.role === 'admin') {
                processedCategories = processedCategories.map((category) => {
                    return {
                        ...category,
                        mode: 'edit',
                    };
                });
            }

            processedCategories = _.sortBy(processedCategories, ['sequence']);
            dispatch(setCategories(processedCategories));
        }
    }, [user, allCategories, dispatch]);

    // Handle logout
    const handleLogout = () => {
        dispatch(removeUser());
    };

    // Don't render if no user
    if (!user) {
        return null;
    }

    return (
        <aside className='main-sidebar'>
            <section className='sidebar'>
                <div className='user-panel'>
                    <span className='logo-lg'>
                        <img
                            src={sidebarOpen ? logo : logoNoText}
                            style={sidebarOpen ? { width: '150px' } : { width: '30px' }}
                            alt='logo'
                        />
                    </span>
                </div>
                <ul className='sidebar-menu' data-widget='tree'>
                    {categories &&
                        categories.map(({ name, link }, ind) => {
                            return (
                                <li key={ind}>
                                    <NavLink
                                        className={({ isActive }) => isActive ? 'active' : ''}
                                        to={'/' + link}
                                    >
                                        <i className='fa fa-dashboard' /> <span>{name}</span>
                                    </NavLink>
                                </li>
                            );
                        })}

                    {user.role === 'admin' && (
                        <React.Fragment>
                            <li>
                                <NavLink
                                    className={({ isActive }) => isActive ? 'active' : ''}
                                    to='/admins'
                                >
                                    <i className='fa fa-dashboard' /> <span>Manage Admins</span>
                                </NavLink>
                            </li>

                            {false && (
                                <li>
                                    <NavLink
                                        className={({ isActive }) => isActive ? 'active' : ''}
                                        to='/new-category'
                                    >
                                        <i className='fa fa-dashboard' /> <span>New Category</span>
                                    </NavLink>
                                </li>
                            )}
                        </React.Fragment>
                    )}
                </ul>

                <ul className='sidebar-menu logout' data-widget='tree'>
                    <li onClick={handleLogout}>
                        <NavLink
                            className={({ isActive }) => isActive ? 'active' : ''}
                            to=''
                        >
                            <i className='fa fa-dashboard' /> <span>Logout</span>
                        </NavLink>
                    </li>
                </ul>
            </section>
        </aside>
    );
};

export default Sidebar;
